/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ActionCondition, { SpecificLinkOption } from 'cio/app-models/conditions/action';
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { ActivityLogType } from 'cio/utils/activity-log-types';
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';

interface Args {
  condition: ActionCondition;
  disabled: boolean;
  allowAllVariationsSelection?: boolean;
  allowForeignEvent: boolean;
  allowInParentWildcardSelection: boolean;
  allowVariationSelection?: boolean;
  allowWildcardSelection: boolean;
  size: string;
  variation: string;
}

export default class Action extends Component<Args> {
  @computed('args.condition.{type,eventType}')
  get showSpecificLink() {
    let { eventType } = this.args.condition;
    return eventType === ActivityLogType.ClickedAction;
  }

  @computed('args.condition.{type,specificLink}')
  get showLinkHref() {
    let { specificLink, type } = this.args.condition;
    return this.showSpecificLink && specificLink !== SpecificLinkOption.None && type !== MessagingChannelType.InApp;
  }

  @computed('args.condition.{type,specificLink}')
  get showTrackedResponseName() {
    let { type, specificLink } = this.args.condition;
    return this.showSpecificLink && specificLink !== SpecificLinkOption.None && type === MessagingChannelType.InApp;
  }
}
